import React from 'react';
import { Text, View } from 'react-native';
import type { StyleMap } from 'Types';

import InfoValues from './components/InfoValues/InfoValues';
import getStyles from './styles';

export interface InfoItemValue {
    value: string | { firstName: string; lastName: string; fullName: string };
    isLink?: boolean;
    children: JSX.Element | JSX.Element[];
    onPress: () => void;
    link: string;
}

export interface InfoListProps {
    // eslint-disable-next-line react/require-default-props
    style?: StyleMap;
    isPlayerInfo: boolean;
    // eslint-disable-next-line react/require-default-props
    items?: {
        label: string;
        values: InfoItemValue[];
        children?: JSX.Element | JSX.Element[];
        onPress?: () => void;
    }[];
    onNavigate: () => void;
    isSingleColumn: boolean;
}

const InfoList = ({
    style = {},
    isPlayerInfo = false,
    items,
    onNavigate,
    isSingleColumn = false
}: InfoListProps): JSX.Element => {
    const { container, itemContainer, itemLabel, itemValues } = getStyles({
        isSingleColumn,
        isPlayerInfo
    });

    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (!items) return <></>;

    return (
        <View style={[container, style]}>
            {items.map((item) => (
                <View key={item.label} style={itemContainer}>
                    <Text style={itemLabel}>{item.label}</Text>
                    <View style={itemValues}>
                        <InfoValues
                            isPlayerInfo={isPlayerInfo}
                            onNavigate={onNavigate}
                            values={item.values}
                        />
                    </View>
                </View>
            ))}
        </View>
    );
};

export default React.memo(InfoList);
